import React, { useState, ReactElement } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  NavLink,
  useHistory,
} from "react-router-dom";

import { IconInstagram, IconHamburger, IconX } from "../icons";

import andromacheSrc from "../images/illustration/andromache.png";
import andromacheLightbox from "../images/illustration/andromache_by_jessichenliu.png";
const andromache: GalleryImage = {
  src: andromacheSrc,
  lightboxSrc: andromacheLightbox,
  title: <span><i>Andromache Between Worlds</i> cover</span>,
  description: "HarperCollins, AD: Mark Campbell"
};

import andromache2Src from "../images/illustration/andromache2.png";
import andromache2Lightbox from "../images/illustration/andromache2_by_jessichenliu.png";
const andromache2: GalleryImage = {
  src: andromache2Src,
  lightboxSrc: andromache2Lightbox,
  title: <span><i>Andromache in the Dark</i> cover</span>,
  description: "HarperCollins, AD: Rachel Walker"
};

import andromache2fullSrc from "../images/illustration/andromache2full.jpg";
import andromache2fullLightbox from "../images/illustration/andromache2full_by_jessichenliu.jpg";
const andromache2full: GalleryImage = {
  src: andromache2fullSrc,
  lightboxSrc: andromache2fullLightbox,
  title: <span><i>Andromache in the Dark</i> cover</span>,
  description: "HarperCollins, AD: Rachel Walker"
};

import apoPianoSrc from "../images/illustration/apo_piano.png";
import apoPianoLightbox from "../images/illustration/apo_piano_by_jessichenliu.png";
const apoPiano: GalleryImage = {
  src: apoPianoSrc,
  lightboxSrc: apoPianoLightbox,
};

import apoTaichiSrc from "../images/illustration/apo_taichi.png";
import apoTaichiLightbox from "../images/illustration/apo_taichi_by_jessichenliu.png";
const apoTaichi = {
  src: apoTaichiSrc,
  lightboxSrc: apoTaichiLightbox,
};

import apoMathSrc from "../images/illustration/apo_math.png";
import apoMathLightbox from "../images/illustration/apo_math_by_jessichenliu.png";
const apoMath: GalleryImage = { src: apoMathSrc, lightboxSrc: apoMathLightbox };

import apoKitchenSrc from "../images/illustration/apo_kitchen.png";
import apoKitchenLightbox from "../images/illustration/apo_kitchen_by_jessichenliu.png";
const apoKitchen: GalleryImage = { src: apoKitchenSrc, lightboxSrc: apoKitchenLightbox };

import thumbelinaSrc from "../images/illustration/thumbelina.png";
import thumbelinaLightbox from "../images/illustration/thumbelina_by_jessichenliu.png";
const thumbelina: GalleryImage = { src: thumbelinaSrc, lightboxSrc: thumbelinaLightbox };

import charlieSrc from "../images/illustration/charlie_chocolate_factory.png";
import charlieLightbox from "../images/illustration/charlie_chocolate_factory_by_jessichenliu.png";
const charlie: GalleryImage = { src: charlieSrc, lightboxSrc: charlieLightbox };

import fishSrc from "../images/illustration/fish.png";
import fishLightbox from "../images/illustration/fish_by_jessichenliu.png";
const fish: GalleryImage = { src: fishSrc, lightboxSrc: fishLightbox };

import liftSrc from "../images/illustration/lift.png";
import liftLightbox from "../images/illustration/lift_by_jessichenliu.png";
const lift: GalleryImage = { src: liftSrc, lightboxSrc: liftLightbox };

import witSrc from "../images/illustration/wit.png";
import witLightbox from "../images/illustration/wit_by_jessichenliu.png";
const wit: GalleryImage = { src: witSrc, lightboxSrc: witLightbox };

import sylSrc from "../images/illustration/syl.png";
import sylLightbox from "../images/illustration/syl_by_jessichenliu.png";
const syl: GalleryImage = { src: sylSrc, lightboxSrc: sylLightbox };

import shallanSrc from "../images/illustration/shallan.png";
import shallanLightbox from "../images/illustration/shallan_by_jessichenliu.png";
const shallan: GalleryImage = { src: shallanSrc, lightboxSrc: shallanLightbox };

import mongoliaSrc from "../images/illustration/mongolia.png";
import mongoliaLightbox from "../images/illustration/mongolia_by_jessichenliu.png";
const mongolia: GalleryImage = { src: mongoliaSrc, lightboxSrc: mongoliaLightbox };

import tibetSrc from "../images/illustration/tibet.png";
import tibetLightbox from "../images/illustration/tibet_by_jessichenliu.png";
const tibet: GalleryImage = { src: tibetSrc, lightboxSrc: tibetLightbox };

import witchesSrc from "../images/illustration/witches.png";
import witchesLightbox from "../images/illustration/witches_by_jessichenliu.png";
const witches: GalleryImage = { src: witchesSrc, lightboxSrc: witchesLightbox };

import bandSrc from "../images/illustration/band.png";
import bandLightbox from "../images/illustration/band_by_jessichenliu.png";
const band: GalleryImage = { src: bandSrc, lightboxSrc: bandLightbox };

import xianSrc from "../images/illustration/xian.png";
import xianLightbox from "../images/illustration/xian_by_jessichenliu.png";
const xian: GalleryImage = { src: xianSrc, lightboxSrc: xianLightbox };

import booksSrc from "../images/illustration/books.png";
import booksLightbox from "../images/illustration/books_by_jessichenliu.png";
const books: GalleryImage = { src: booksSrc, lightboxSrc: booksLightbox };

import jasnahSrc from "../images/illustration/jasnah.png";
import jasnahLightbox from "../images/illustration/jasnah_by_jessichenliu.png";
const jasnah: GalleryImage = { src: jasnahSrc, lightboxSrc: jasnahLightbox };

import violetSrc from "../images/illustration/violet.png";
import violetLightbox from "../images/illustration/violet_by_jessichenliu.png";

const violet: GalleryImage = {
  src: violetSrc,
  lightboxSrc: violetLightbox,
  title: <span><i>Violet Made of Thorns</i> front endpaper</span>,
  description: "Unieboek Het Spectrum, AD: Arienne Huisman"
};

import cyrusSrc from "../images/illustration/cyrus.png";
import cyrusLightbox from "../images/illustration/cyrus_by_jessichenliu.png";
const cyrus: GalleryImage = {
  src: cyrusSrc,
  lightboxSrc: cyrusLightbox,
  title: <span><i>Violet Made of Thorns</i> back endpaper</span>,
  description: "Unieboek Het Spectrum, AD: Arienne Huisman"
};

import fireheartSrc from "../images/illustration/fireheart.png";
import fireheartLightbox from "../images/illustration/fireheart_by_jessichenliu.png";
const fireheart: GalleryImage = {
  src: fireheartSrc,
  lightboxSrc: fireheartLightbox,
  title: <span><i>Fire Heart</i> cover</span>,
  description: "Scholastic, AD: Geraldine Dutton"
};

import vivennaSrc from "../images/illustration/vivenna.png";
import vivennaLightbox from "../images/illustration/vivenna_by_jessichenliu.png";
const vivenna: GalleryImage = { src: vivennaSrc, lightboxSrc: vivennaLightbox };

import yumiSrc from "../images/illustration/yumi.png";
import yumiLightbox from "../images/illustration/yumi_by_jessichenliu.png";
const yumi: GalleryImage = { src: yumiSrc, lightboxSrc: yumiLightbox };

import tressSrc from "../images/illustration/tress.png";
import tressLightbox from "../images/illustration/tress_by_jessichenliu.png";
const tress: GalleryImage = { src: tressSrc, lightboxSrc: tressLightbox };

import kiraPlaneSrc from "../images/illustration/kira_plane.png";
import kiraPlaneLightbox from "../images/illustration/kira_plane_by_jessichenliu.png";
const kiraPlane: GalleryImage = {
  src: kiraPlaneSrc,
  lightboxSrc: kiraPlaneLightbox ,
  title: <span><i>Kira and Dad in Vietnam</i></span>,
  description: "Teacher Created Materials, AD: Fabiola Sepulveda"
}

import kiraBikeSrc from "../images/illustration/kira_bike.png";
import kiraBikeLightbox from "../images/illustration/kira_bike_by_jessichenliu.png";
const kiraBike: GalleryImage = {
  src: kiraBikeSrc,
  lightboxSrc: kiraBikeLightbox,
  title: <span><i>Kira and Dad in Vietnam</i></span>,
  description: "Teacher Created Materials, AD: Fabiola Sepulveda"
};

import macabeesSrc from "../images/illustration/macabees.png";
import macabeesLightbox from "../images/illustration/macabees_by_jessichenliu.png";
const macabees: GalleryImage = {
  src: macabeesSrc,
  lightboxSrc: macabeesLightbox,
  title: <span><i>Eight Bright Nights</i> pages 5-6</span>,
  description: "Hachai Publishing, AD: Devorah Rosenfeld"
};

import latkesSrc from "../images/illustration/latkes.png";
import latkesLightbox from "../images/illustration/latkes_by_jessichenliu.png";
const latkes: GalleryImage = {
  src: latkesSrc,
  lightboxSrc: latkesLightbox,
  title: <span><i>Eight Bright Nights</i> pages 11-12</span>,
  description: "Hachai Publishing, AD: Devorah Rosenfeld"
};

import goatSrc from "../images/illustration/goat.png";
import goatLightbox from "../images/illustration/goat_by_jessichenliu.png";
const goat: GalleryImage = { src: goatSrc, lightboxSrc: goatLightbox };

import ratSrc from "../images/illustration/rat.png";
import ratLightbox from "../images/illustration/rat_by_jessichenliu.png";
const rat: GalleryImage = { src: ratSrc, lightboxSrc: ratLightbox };

import dragonSrc from "../images/illustration/dragon.png";
import dragonLightbox from "../images/illustration/dragon_by_jessichenliu.png";
const dragon: GalleryImage = { src: dragonSrc, lightboxSrc: dragonLightbox };

import roosterSrc from "../images/illustration/rooster.png";
import roosterLightbox from "../images/illustration/rooster_by_jessichenliu.png";
const rooster: GalleryImage = { src: roosterSrc, lightboxSrc: roosterLightbox };

import vinSrc from "../images/illustration/vin.png";
import vinLightbox from "../images/illustration/vin_by_jessichenliu.png";
const vin: GalleryImage = { src: vinSrc, lightboxSrc: vinLightbox };

import wickedSrc from "../images/illustration/wicked.jpg";
import wickedLightbox from "../images/illustration/wicked_by_jessichenliu.jpg";
const wicked: GalleryImage = { src: wickedSrc, lightboxSrc: wickedLightbox };

import forestrunSrc from "../images/illustration/forestrun.png";
import forestrunLightbox from "../images/illustration/forestrun_by_jessichenliu.png";
const forestrun: GalleryImage = { src: forestrunSrc, lightboxSrc: forestrunLightbox };

import tawnymanSrc from "../images/illustration/tawnyman.png";
import tawnymanLightbox from "../images/illustration/tawnyman_by_jessichenliu.png";
const tawnyman: GalleryImage = { src: tawnymanSrc, lightboxSrc: tawnymanLightbox };

import shadesofmagic1Src from "../images/illustration/shadesofmagic1.png";
import shadesofmagic1Lightbox from "../images/illustration/shadesofmagic1_by_jessichenliu.png";
const shadesofmagic1: GalleryImage = {
  src: shadesofmagic1Src,
  lightboxSrc: shadesofmagic1Lightbox,
  title: <span><i>A Darker Shade of Magic</i> tip-in</span>,
  description: "Owlcrate, AD: Sho Ling He Feng"
};

import shadesofmagic2Src from "../images/illustration/shadesofmagic2.png";
import shadesofmagic2Lightbox from "../images/illustration/shadesofmagic2_by_jessichenliu.png";
const shadesofmagic2: GalleryImage = {
  src: shadesofmagic2Src,
  lightboxSrc: shadesofmagic2Lightbox,
  title: <span><i>A Gathering of Shadows</i> tip-in</span>,
  description: "Owlcrate, AD: Sho Ling He Feng"
};

import shadesofmagic3Src from "../images/illustration/shadesofmagic3.png";
import shadesofmagic3Lightbox from "../images/illustration/shadesofmagic3_by_jessichenliu.png";
const shadesofmagic3: GalleryImage = {
  src: shadesofmagic3Src,
  lightboxSrc: shadesofmagic3Lightbox,
  title: <span><i>A Conjuring of Light</i> tip-in</span>,
  description: "Owlcrate, AD: Sho Ling He Feng"
};

import smallfortunes1Src from "../images/illustration/smallfortunes1.png";
import smallfortunes1Lightbox from "../images/illustration/smallfortunes1_by_jessichenliu.png";
const smallfortunes1: GalleryImage = {
  src: smallfortunes1Src,
  lightboxSrc: smallfortunes1Lightbox,
  title: <span><i>Teller of Small Fortunes</i> endpaper</span>,
  description: "Owlcrate, AD: Teresa Chen"
};

import maskofmirrors1Src from "../images/illustration/maskofmirrors1.png";
import maskofmirrors1Lightbox from "../images/illustration/maskofmirrors1_by_jessichenliu.png";
const maskofmirrors1: GalleryImage = {
  src: maskofmirrors1Src,
  lightboxSrc: maskofmirrors1Lightbox,
  title: <span><i>Mask of Mirrors</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import maskofmirrors2Src from "../images/illustration/maskofmirrors2.png";
import maskofmirrors2Lightbox from "../images/illustration/maskofmirrors2_by_jessichenliu.png";
const maskofmirrors2: GalleryImage = {
  src: maskofmirrors2Src,
  lightboxSrc: maskofmirrors2Lightbox,
  title: <span><i>Mask of Mirrors</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import maskofmirrors3Src from "../images/illustration/maskofmirrors3.png";
import maskofmirrors3Lightbox from "../images/illustration/maskofmirrors3_by_jessichenliu.png";
const maskofmirrors3: GalleryImage = {
  src: maskofmirrors3Src,
  lightboxSrc: maskofmirrors3Lightbox,
  title: <span><i>Mask of Mirrors</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import liarsknot1Src from "../images/illustration/liarsknot1.png";
import liarsknot1Lightbox from "../images/illustration/liarsknot1_by_jessichenliu.png";
const liarsknot1: GalleryImage = {
  src: liarsknot1Src,
  lightboxSrc: liarsknot1Lightbox,
  title: <span><i>Liar's Knot</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import liarsknot2Src from "../images/illustration/liarsknot2.png";
import liarsknot2Lightbox from "../images/illustration/liarsknot2_by_jessichenliu.png";
const liarsknot2: GalleryImage = {
  src: liarsknot2Src,
  lightboxSrc: liarsknot2Lightbox,
  title: <span><i>Liar's Knot</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import liarsknot3Src from "../images/illustration/liarsknot3.png";
import liarsknot3Lightbox from "../images/illustration/liarsknot3_by_jessichenliu.png";
const liarsknot3: GalleryImage = {
  src: liarsknot3Src,
  lightboxSrc: liarsknot3Lightbox,
  title: <span><i>Liar's Knot</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import labyrinthsheart1Src from "../images/illustration/labyrinthsheart1.png";
import labyrinthsheart1Lightbox from "../images/illustration/labyrinthsheart1_by_jessichenliu.png";
const labyrinthsheart1: GalleryImage = {
  src: labyrinthsheart1Src,
  lightboxSrc: labyrinthsheart1Lightbox,
  title: <span><i>Labyrinth's Heart</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import labyrinthsheart2Src from "../images/illustration/labyrinthsheart2.png";
import labyrinthsheart2Lightbox from "../images/illustration/labyrinthsheart2_by_jessichenliu.png";
const labyrinthsheart2: GalleryImage = {
  src: labyrinthsheart2Src,
  lightboxSrc: labyrinthsheart2Lightbox,
  title: <span><i>Labyrinth's Heart</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import labyrinthsheart3Src from "../images/illustration/labyrinthsheart3.png";
import labyrinthsheart3Lightbox from "../images/illustration/labyrinthsheart3_by_jessichenliu.png";
const labyrinthsheart3: GalleryImage = {
  src: labyrinthsheart3Src,
  lightboxSrc: labyrinthsheart3Lightbox,
  title: <span><i>Labyrinth's Heart</i> interior art</span>,
  description: "The Broken Binding, AD: Petrik Leo"
};

import sixrealms1Src from "../images/illustration/sixrealms1.png";
import sixrealms1Lightbox from "../images/illustration/sixrealms1_by_jessichenliu.png";
const sixrealms1: GalleryImage = {
  src: sixrealms1Src,
  lightboxSrc: sixrealms1Lightbox,
  title: <span><i>Song of the Six Realms</i> endpaper</span>,
  description: "Owlcrate, AD: Sho Ling He Feng"
};

import sixrealms2Src from "../images/illustration/sixrealms2.png";
import sixrealms2Lightbox from "../images/illustration/sixrealms2_by_jessichenliu.png";
const sixrealms2: GalleryImage = {
  src: sixrealms2Src,
  lightboxSrc: sixrealms2Lightbox,
  title: <span><i>Song of the Six Realms</i> endpaper</span>,
  description: "Owlcrate, AD: Sho Ling He Feng"
};

import forgeryoffateSrc from "../images/illustration/forgeryoffate.png";
import forgeryoffateLightbox from "../images/illustration/forgeryoffate_by_jessichenliu.png";
const forgeryoffate: GalleryImage = {
  src: forgeryoffateSrc,
  lightboxSrc: forgeryoffateLightbox,
  title: <span><i>A Forgery of Fate</i> endpaper</span>,
  description: "Owlcrate, AD: Yeatasmin Shiropa"
};

import summers1Src from "../images/illustration/summers1.png";
import summers1Lightbox from "../images/illustration/summers1_by_jessichenliu.png";
const summers1: GalleryImage = {
  src: summers1Src,
  lightboxSrc: summers1Lightbox,
  title: <span><i>The Summers Between Us</i> promo</span>,
  description: "Penguin Random House, AD: Polly Beel, Noreen Nanja"
};

import summers2Src from "../images/illustration/summers2.png";
import summers2Lightbox from "../images/illustration/summers2_by_jessichenliu.png";
const summers2: GalleryImage = {
  src: summers2Src,
  lightboxSrc: summers2Lightbox,
  title: <span><i>The Summers Between Us</i> promo</span>,
  description: "Penguin Random House, AD: Polly Beel, Noreen Nanja"
};

import dawnofthefirebirdSrc from "../images/illustration/dawnofthefirebird.jpg";
import dawnofthefirebirdLightbox from "../images/illustration/dawnofthefirebird_by_jessichenliu.jpg";
const dawnofthefirebird: GalleryImage = {
  src: dawnofthefirebirdSrc,
  lightboxSrc: dawnofthefirebirdLightbox,
  title: <span><i>Dawn of the Firebird</i> promo</span>,
  description: "AD: Sarah Mughal Rana"
};

import dominionSrc from "../images/illustration/dominion.jpg";
import dominionLightbox from "../images/illustration/dominion_by_jessichenliu.jpg";
const dominion: GalleryImage = {
  src: dominionSrc,
  lightboxSrc: dominionLightbox,
  title: <span><i>Dominion</i> cover</span>,
  description: "Putnam Books, AD: Sanny Chiu"
};

import kpopgirlsSrc from "../images/illustration/kpopgirls.jpg";
import kpopgirlsLightbox from "../images/illustration/kpopgirls_by_jessichenliu.jpg";
const kpopgirls: GalleryImage = {
  src: kpopgirlsSrc,
  lightboxSrc: kpopgirlsLightbox
};

import fasttrackSrc from "../images/illustration/fasttrack.jpg";
import fasttrackLightbox from "../images/illustration/fasttrack_by_jessichenliu.jpg";
const fasttrack: GalleryImage = {
  src: fasttrackSrc,
  lightboxSrc: fasttrackLightbox,
  description: "Simon & Schuster, AD: Sarah Creech"
};

import tressesSrc from "../images/illustration/tresses.jpg";
import tressesLightbox from "../images/illustration/tresses_by_jessichenliu.jpg";
const tresses: GalleryImage = {
  src: tressesSrc,
  lightboxSrc: tressesLightbox
};

import forgeryoffate2Src from "../images/illustration/forgeryoffate2.jpg";
import forgeryoffate2Lightbox from "../images/illustration/forgeryoffate2_by_jessichenliu.jpg";
const forgeryoffate2: GalleryImage = {
  src: forgeryoffate2Src,
  lightboxSrc: forgeryoffate2Lightbox
};

import syldandelionSrc from "../images/illustration/syldandelion.jpg";
import syldandelionLightbox from "../images/illustration/syldandelion_by_jessichenliu.jpg";
const syldandelion: GalleryImage = {
  src: syldandelionSrc,
  lightboxSrc: syldandelionLightbox
};

import rapunzelsmotherSrc from "../images/illustration/rapunzelsmother.jpg";
import rapunzelsmotherLightbox from "../images/illustration/rapunzelsmother_by_jessichenliu.jpg";
const rapunzelsmother: GalleryImage = {
  src: rapunzelsmotherSrc,
  lightboxSrc: rapunzelsmotherLightbox
};

import neheleniaSrc from "../images/illustration/nehelenia.jpg";
import neheleniaLightbox from "../images/illustration/nehelenia_by_jessichenliu.jpg";
const nehelenia: GalleryImage = {
  src: neheleniaSrc,
  lightboxSrc: neheleniaLightbox
};

import scholomanceSrc from "../images/illustration/scholomance.jpg";
import scholomanceLightbox from "../images/illustration/scholomance_by_jessichenliu.jpg";
const scholomance: GalleryImage = {
  src: scholomanceSrc,
  lightboxSrc: scholomanceLightbox
};

import fatesocold1Src from "../images/illustration/fatesocold1.jpg";
import fatesocold1Lightbox from "../images/illustration/fatesocold1_by_jessichenliu.jpg";
const fatesocold1: GalleryImage = {
  src: fatesocold1Src,
  lightboxSrc: fatesocold1Lightbox,
  title: <span><i>A Fate So Cold</i> endpaper</span>,
  description: "Owlcrate, AD: Yeatasmin Shiropa"
};

import fatesocold2Src from "../images/illustration/fatesocold2.jpg";
import fatesocold2Lightbox from "../images/illustration/fatesocold2_by_jessichenliu.jpg";
const fatesocold2: GalleryImage = {
  src: fatesocold2Src,
  lightboxSrc: fatesocold2Lightbox,
  title: <span><i>A Fate So Cold</i> endpaper</span>,
  description: "Owlcrate, AD: Yeatasmin Shiropa"
};

import stayforaspellSrc from "../images/illustration/stayforaspell.jpg";
import stayforaspellLightbox from "../images/illustration/stayforaspell_by_jessichenliu.jpg";
const stayforaspell: GalleryImage = {
  src: stayforaspellSrc,
  lightboxSrc: stayforaspellLightbox,
  title: <span><i>Stay For A Spell</i> cover</span>,
  description: "Ace Books, AD: Katie Anderson"
};

import prisonerSrc from "../images/illustration/prisoner.png";
import prisonerLightbox from "../images/illustration/prisoner_by_jessichenliu.png";
const prisoner: GalleryImage = {
  src: prisonerSrc,
  lightboxSrc: prisonerLightbox,
  title: <span><i>Cosmere RPG, Stonewalkers Adventure</i></span>,
  description: "Brotherwise Games, AD: Katie Payne"
};

import mistbornunveilSrc from "../images/illustration/mistbornunveil.png";
import mistbornunveilLightbox from "../images/illustration/mistbornunveil_by_jessichenliu.png";
const mistbornunveil: GalleryImage = {
  src: mistbornunveilSrc,
  lightboxSrc: mistbornunveilLightbox,
  title: <span><i>Mistborn Deckbuilding Game</i> card</span>,
  description: "Brotherwise Games, AD: Katie Payne"
};

import processSrc from "../images/illustration/process.png";
import processLightbox from "../images/illustration/process_by_jessichenliu.png";
const process: GalleryImage = { src: processSrc, lightboxSrc: processLightbox };

import hungryghostsSrc from "../images/illustration/hungryghosts.jpg";
import hungryghostsLightbox from "../images/illustration/hungryghosts_by_jessichenliu.jpg";
const hungryghosts: GalleryImage = { 
  src: hungryghostsSrc, 
  lightboxSrc: hungryghostsLightbox,
  title: <span><i>Harbour of Hungry Ghosts</i> promo</span>,
  description: "AD: Eliza Chan"
};

import silverkingdomSrc from "../images/illustration/silverkingdom.jpg";
import silverkingdomLightbox from "../images/illustration/silverkingdom_by_jessichenliu.jpg";
const silverkingdom: GalleryImage = { 
  src: silverkingdomSrc, 
  lightboxSrc: silverkingdomLightbox,
  title: <span><i>The Silver Kingdom</i> cover</span>,
  description: "Simon & Schuster, AD: Lucy Cummins"
};

import silverkingdomdustjacketSrc from "../images/illustration/silverkingdomdustjacket.jpg";
import silverkingdomdustjacketLightbox from "../images/illustration/silverkingdomdustjacket_by_jessichenliu.jpg";
const silverkingdomdustjacket: GalleryImage = { 
  src: silverkingdomdustjacketSrc, 
  lightboxSrc: silverkingdomdustjacketLightbox,
  title: <span><i>The Silver Kingdom</i> dust jacket</span>,
  description: "Simon & Schuster, AD: Lucy Cummins"
};

import wingedgameSrc from "../images/illustration/wingedgame.jpg";
import wingedgameLightbox from "../images/illustration/wingedgame_by_jessichenliu.jpg";
const wingedgame: GalleryImage = { 
  src: wingedgameSrc, 
  lightboxSrc: wingedgameLightbox,
  title: <span><i>The Winged Game</i> endpaper</span>,
  description: "Del Rey, AD: Sarah Horgan"
};

import flatbrushSrc from "../images/illustration/flatbrush.jpg";
import flatbrushLightbox from "../images/illustration/flatbrush_by_jessichenliu.jpg";
const flatbrush: GalleryImage = { 
  src: flatbrushSrc, 
  lightboxSrc: flatbrushLightbox,
  title: <span>Flatbrush promo</span>,
  description: ""
};

import dracoSrc from "../images/illustration/draco.jpg";
import dracoLightbox from "../images/illustration/draco_by_jessichenliu.jpg";
const draco: GalleryImage = { 
  src: dracoSrc, 
  lightboxSrc: dracoLightbox
};

import ghostofexespastSrc from "../images/illustration/ghostofexespast.jpg";
import ghostofexespastLightbox from "../images/illustration/ghostofexespast_by_jessichenliu.jpg";
const ghostofexespast: GalleryImage = { 
  src: ghostofexespastSrc, 
  lightboxSrc: ghostofexespastLightbox,
  title: <span><i>The Ghost of Exes Past</i> cover</span>,
  description: "Avon Books, AD: Toby James"
};

import neverletmegoSrc from "../images/illustration/neverletmego.jpg";
import neverletmegoLightbox from "../images/illustration/neverletmego_by_jessichenliu.jpg";
const neverletmego: GalleryImage = { 
  src: neverletmegoSrc, 
  lightboxSrc: neverletmegoLightbox
};

import romantasylandSrc from "../images/illustration/romantasyland.jpg";
import romantasylandLightbox from "../images/illustration/romantasyland_by_jessichenliu.jpg";
const romantasyland: GalleryImage = { 
  src: romantasylandSrc, 
  lightboxSrc: romantasylandLightbox,
  title: <span><i>Romantasyland</i> cover</span>,
  description: "Dell, AD & Typography: Sarah Horgan"
};

import darkwizardfallsinloveSrc from "../images/illustration/darkwizardfallsinlove.jpg";
import darkwizardfallsinloveLightbox from "../images/illustration/darkwizardfallsinlove_by_jessichenliu.jpg";
const darkwizardfallsinlove: GalleryImage = { 
  src: darkwizardfallsinloveSrc, 
  lightboxSrc: darkwizardfallsinloveLightbox,
  title: <span><i>The Dark Wizard Falls in Love</i> cover</span>,
  description: "Ace Books, AD: Katie Anderson"
};

import heartstringpullerSrc from "../images/illustration/heartstringpuller.jpg";
import heartstringpullerLightbox from "../images/illustration/heartstringpuller_by_jessichenliu.jpg";
const heartstringpuller: GalleryImage = { 
  src: heartstringpullerSrc, 
  lightboxSrc: heartstringpullerLightbox,
  title: <span><i>Heartstring Puller</i></span>,
  description: "Magic: The Gathering, AD: Deborah Garcia"
};

import lastcallSrc from "../images/illustration/lastcall.jpg";
import lastcallLightbox from "../images/illustration/lastcall_by_jessichenliu.jpg";
const lastcall: GalleryImage = { 
  src: lastcallSrc, 
  lightboxSrc: lastcallLightbox,
  title: <span><i>Last Call</i> cover</span>,
  description: "Berkley, AD: Lila Selle"
};

import marwynSrc from "../images/illustration/marwyn.jpg";
import marwynLightbox from "../images/illustration/marwyn_by_jessichenliu.jpg";
const marwyn: GalleryImage = { 
  src: marwynSrc, 
  lightboxSrc: marwynLightbox,
  title: <span><i>Marwyn, the Clearcutter | Marwyn, the Preserver</i></span>,
  description: "Magic: The Gathering, AD: Sarah Wassell"
};

import heirofruinSrc from "../images/illustration/heirofruin.jpg";
import heirofruinLightbox from "../images/illustration/heirofruin_by_jessichenliu.jpg";
const heirofruin: GalleryImage = { 
  src: heirofruinSrc, 
  lightboxSrc: heirofruinLightbox,
  title: <span><i>Heir of Ruin</i> cover</span>,
  description: "Forever, AD: Daniela Medina"
};

import shadowsixSrc from "../images/illustration/shadowsix.jpg";
import shadowsixLightbox from "../images/illustration/shadowsix_by_jessichenliu.jpg";
const shadowsix: GalleryImage = {
  src: shadowsixSrc,
  lightboxSrc: shadowsixLightbox,
  title: <span><i>The Shadow Six</i> dust jacket</span>,
  description: "Simon & Schuster, AD: Tiara Iandiorio"
};

import jessica from "../images/about.png";
import koby from "../images/koby.jpg";
import sacha from "../images/sacha.jpg";
import koby2 from "../images/koby2.jpg";
import keturahrose from "../images/keturahrose.jpg";
import artikuta from "../images/artikuta.jpg";
import dominionprocess from "../images/dominionprocess.jpg";

import { Lightbox } from "./Lightbox";
import { GalleryImage, GalleryRow } from "./GalleryRow";
import { IconButton } from "./IconButton";
import { GalleryGrid } from "./GalleryGrid";

export const ResizeObserver = (window as any).ResizeObserver;

export const MAX_WIDTH = 1440;
export const MOBILE_BREAK = 720;


const illustrationGalleryRows: GalleryImage[][] = [
  [ghostofexespast, romantasyland, dominion],
  [silverkingdomdustjacket],
  [wingedgame, flatbrush],
  [marwyn, heartstringpuller],
  [draco, nehelenia, wicked],
  [darkwizardfallsinlove, stayforaspell],
];

const newGalleryRows: GalleryImage[][] = illustrationGalleryRows;

const wotcGalleryRows: GalleryImage[][] = [
  [dawnofthefirebird],
  [rooster, rat, goat],
  [labyrinthsheart2, labyrinthsheart3, labyrinthsheart1],
  [dragon],
  [shadesofmagic1, shadesofmagic2, shadesofmagic3],
  [forestrun],
  [maskofmirrors1, maskofmirrors2, maskofmirrors3],
  [process],
];

const disneyRows: GalleryImage[][] = [
  [mongolia, thumbelina],
  [andromache, andromache2full],
  [apoKitchen, apoTaichi, apoMath],
  [tresses, kpopgirls, fasttrack],
  [shallan, yumi, syldandelion],
  [fatesocold1, fatesocold2],
  [nehelenia, forgeryoffate2],
  [stayforaspell, summers1, dominion]
]

const rookAndRoseGalleryRows: GalleryImage[][] = [
  [maskofmirrors1, maskofmirrors2, maskofmirrors3],
  [liarsknot1, liarsknot2, liarsknot3],
  [labyrinthsheart1, labyrinthsheart2, labyrinthsheart3],
];

const kidlitGalleryRows: GalleryImage[][] = [
  [thumbelina, andromache, andromache2],
  [shallan, mongolia],
  [apoTaichi, apoKitchen, apoMath],
];

function About() {
  return (
    <>
      <div className="two-col-reverse">
        <div>
          <p>
            Hi, I'm Jessica! I'm a freelance illustrator based in San Francisco, specializing in book illustration.
            As a lifelong reader and fanartist, I'm obsessed with capturing the essence of characters and relationships.
            I'm always geeked to read a manuscript, and I love collaborating with my clients to bring their story to life.
            {/* My work features vibrant colors, dynamic lighting and composition, and expressive characters.
            I illustrate in a variety of styles, from Fantasy and YA to Middle Grade and Kidlit. */}
          </p>
          <p>&nbsp;</p>
          <p>
            Some of my past clients include Ace Books, Putnam Books, Del Rey, Simon & Schuster, Penguin Random House, Harper Collins, Scholastic, and Wizards of the Coast (Magic: The Gathering). My work has been featured in Society of Illustrators 68 and Illustration West 64.
          </p>
          <p>&nbsp;</p>
          <p>You can reach me at:</p>
          <p>hello@jessichenliu.com</p>
        </div>
        <img className="width-30" src={jessica} />
      </div>
    </>
  );
}

function Authors() {
  return (
    <div className="one-column">
    <h2>Author commissions</h2>

    <p>
    I love working directly with authors on promotional pieces for their books! However, I usually only have time for a handful of these every year. Since I receive a lot of inquiries, I decided to gather frequently asked questions here.
    </p>

    <h2>Current status: closed</h2>
    <p>
    My commission slots for authors are currently closed. I plan to start scheduling again in December for 2026 projects. Email me if you'd like to join my waitlist, but it's not a guarantee of a future slot. Likewise, I'm not expecting you to hold a commission for me - please do look for another illustrator for your immediate needs! I keep a waitlist in case a slot opens up early for some reason.
    </p>

    <h2>Sliding scale rates</h2>
    <p>
    When I work with a publisher, my rates start at $2000 for a non-cover illustration. If your publisher is paying for the promotional piece, you can tell them this is my rate. They may offer to cover part or all of the fee, and you would cover the rest.
    </p>

    <p>
    If you're paying totally out of pocket, then I charge a sliding scale based on what you can afford. Make me an offer with your honest budget, and I'll consider it.
    </p>

    <h2>How I choose projects</h2>

    <p>
    Things that make me excited about a project:
    </p>

    <ol>
      <p>1. Creative freedom. I appreciate having a couple options to choose from. And I love more open-ended briefs, where the goal is to capture your character(s) and a vibe, instead of a rigidly defined scene. This helps me align your brief to my own artistic goals.</p>
      <p>2. Long timeline. Bless all of you Type A queens who are planning 6 months ahead! I typically need 4-6 weeks to complete a piece, but a timeline of 3-6 months gives me the flexibility to continue accepting commissions from larger clients during that period.</p>
      <p>3. Ultimately I'm looking for briefs that make me think, "Oh that's going to make a striking, iconic image - I want that in my portfolio!!"</p>
    </ol>

    <p>Given my time-consuming process and limited capacity, unfortunately I must decline most inquiries. Please don't take it personally if I do!</p>

    <h2>Thank you</h2>

    <p>
    I just want to say a big thank you for commissioning human artists to make art! I love that this is happening in our industry, and I love seeing artists support artists. You rock!!
    </p>
    </div>
  );
}

function Mentorship() {
  const applyRowRef = React.useRef<HTMLElement>(null);
  const applyCopyRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    const row = applyRowRef.current;
    const copy = applyCopyRef.current;
    if (!row || !copy) return;

    const updateHeight = () => {
      row.style.setProperty("--apply-copy-height", `${copy.getBoundingClientRect().height}px`);
    };
    updateHeight();

    if (ResizeObserver) {
      const observer = new ResizeObserver(updateHeight);
      observer.observe(copy);
      return () => observer.disconnect();
    }

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const mentorshipImages = {
    intro: koby2,
    apply: keturahrose,
    sessionPlan: dominionprocess,
  };

  return (
    <main className="mentorship-page">
    <section className="mentorship-intro" aria-labelledby="mentorship-heading">
    <h2 id="mentorship-heading">Mentorships</h2>
    <div className="mentorship-row mentorship-row--intro">
    <div className="mentorship-copy">

    <p>
    I offer a limited number of 1:1 mini mentorships! How it works:
    </p>

    <ul>
      <li>Four 1-hour sessions for a total of $400 USD.</li>
      <li>We'll develop one new portfolio piece together.</li>
      <li>Sessions are scheduled at your pace, depending on how much time you need for the next stage.</li>
      <li>My availability for calls is limited to weekdays from 10am-12pm PT.</li>
    </ul>

    <p>
    In my experience, I've found 1:1 mentorships to be an incredibly efficient way to gain conceptual insights and train one's eye/taste. I'd love to help you debug your work and figure out how to keep improving. (Professional peers are welcome - let's level up together!)
    </p>
    </div>
    <figure className="mentorship-artwork">
      <img src={mentorshipImages.intro} alt="A black panther surrounded by golden stars and glowing animals, by Koby Hughes" width={2733} height={2000} />
      <figcaption>Mentorship piece by <a href="https://kobyhughes.com/" target="_blank" rel="noopener noreferrer">Koby Hughes</a></figcaption>
    </figure>
    </div>
    </section>

    <section ref={applyRowRef} className="mentorship-row mentorship-row--apply" aria-labelledby="mentorship-apply-heading">
    <figure className="mentorship-artwork">
      <img src={mentorshipImages.apply} alt="A warrior and a flaming figure with a sword, by Keturah Rose" width={1468} height={2152} loading="lazy" />
      <figcaption>Mentorship piece by <a href="https://www.keturahrose.com/" target="_blank" rel="noopener noreferrer">Keturah Rose</a></figcaption>
    </figure>
    <div ref={applyCopyRef} className="mentorship-copy">
    <h2 id="mentorship-apply-heading">How to apply</h2>

    <p>
    Email me at hello@jessichenliu.com with:
    </p>

    <ul>
      <li>Your portfolio</li>
      <li>Your <a href="https://www.muddycolors.com/2020/08/the-goal-folder/" target="_blank">goal folder</a></li>
      <li>What skills you'd like to improve</li>
      <li>Your career goals</li>
    </ul>

    <p>
    I primarily work with intermediate/advanced artists who already have strong drawing fundamentals, but want to raise the quality of their work to a higher professional level. 
    </p>

    <p>
    While I won't be able to accept all applicants, I'll try to at least offer a portfolio review or some written feedback to everyone who applies. If you're unsure whether you're a fit for this mentorship, please email me and I'll be happy to advise.
    </p>
    </div>
    </section>

    <section className="mentorship-testimonials" aria-labelledby="mentorship-testimonials-heading">
    <h2 id="mentorship-testimonials-heading">Testimonials</h2>
    <div className="mentorship-testimonial-grid">
    <article className="mentorship-testimonial">
    <img src={koby} alt="Artwork by Koby Hughes from the mentorship" loading="lazy" />
    <h3><a href="https://kobyhughes.com/" target="_blank">Koby Hughes</a></h3>
    <blockquote className="quote">
    This was an invaluable experience! Jessica is an incredible teacher who works to push you closer to your goals. After every critique I left feeling energized and excited to make changes. Jessica provided tips on selecting brushes and blending which permanently changed the way I approach art and has made a positive difference in all the work I've made since. Seriously helpful and also incredibly fun, I would happily take this course a hundred more times and I'd probably still learn something new each time!
    </blockquote>
    </article>

    <article className="mentorship-testimonial">
    <img src={artikuta} alt="Artwork by Art Ikuta from the mentorship" loading="lazy" />
    <h3><a href="https://www.artikuta.com/" target="_blank" rel="noopener noreferrer">Art Ikuta</a></h3>
    <blockquote className="quote">
    Jessica was such an incredible mentor and really helped me break through and solidify some ideas to help me take another step forward in my work. So if you're feeling stuck and you want to get some really helpful insights you should definitely hit her up.
    </blockquote>
    </article>

    <article className="mentorship-testimonial">
    <img src={sacha} alt="Artwork by Sacha van Andel from the mentorship" loading="lazy" />
    <h3><a href="https://www.sachiiadraws.com/" target="_blank">Sacha van Andel</a></h3>
    <blockquote className="quote">
    I loved doing my 1:1 mentorship with Jessica. I got incredibly useful insights into the book illustrating business. We brainstormed a new portfolio piece for me to make that was within my comfort zone but allowed me to really push my skills with Jessica's guidance. She was encouraging, kind and knowledgeable. She helped me make my piece the best it could be, while always leaving room for my own artistic preferences.
    </blockquote>
    </article>

    {/* <p>
      <span className="quote">
      “behold .... my magmum opus. i'm about to have this printed and taped to people's doors im so proud of it aaaa!! feels like a real benchmark in my work!!! under @jessichenliu 's wonderful guidance, i owe her my life HAHAHA”
      </span> - Koby Hughes
    </p> */}
    </div>
    </section>

    <section className="mentorship-session-plan" aria-labelledby="mentorship-session-heading">
    <h2 id="mentorship-session-heading">Session plan</h2>
    <div className="mentorship-row mentorship-row--session">
    <div className="mentorship-copy">

    <p>
    This is roughly how the sessions break down, though I expect some variance. I'll give live paintover crits in each session.
    </p>

    <h3>Session 1: Portfolio review</h3>

    <ul>
      <li>We'll analyze your portfolio against your goal folder and discuss the gaps, prioritizing what to focus on.</li>
      <li>We'll decide on a new piece to work on for the mentorship.</li>
    </ul>

    <h3>Session 2: Initial sketches</h3>

    <ul>
      <li>Gather references on anything and everything related to subject matter, character likeness, costume, pose, color palette, art style, etc.</li>
      <li>Sketches can be b&w (preferably 3 value) or color</li>
    </ul>

    <h3>Session 3: Refined color sketch</h3>

    <ul>
      <li>Gather more reference, including color palette reference</li>
      <li>Rough color explorations</li>
      <li>Refined color sketch with at least faces painted in. (The more drawing you solve at this stage, the more useful our crit will be.)</li>
    </ul>

    <h3>Session 4: Final piece</h3>

    <ul>
      <li>Even more reference, including shooting your own reference for lighting, hands, fabric, etc</li>
      <li>Render to your highest level of polish</li>
    </ul>

    <p>
    I'll be reachable on discord in between sessions if you have any questions or want quick eyes on something.
    </p>
    </div>
    <figure className="mentorship-artwork">
      <img src={mentorshipImages.sessionPlan} alt="Dominion cover illustration process, from thumbnail sketches and color studies to the final painting" width={1209} height={3174} loading="lazy" />
    </figure>
    </div>
    </section>

    <section className="mentorship-recommendations" aria-labelledby="mentorship-other-heading">
    <h2 id="mentorship-other-heading">Other mentorships / classes</h2>
    <div className="mentorship-recommendation-grid">
    <div className="mentorship-copy">

    <p>
    In case I'm not the best fit for you at this time, here are some other classes and mentorships I can recommend:
    </p>

    <h3>Smarter Art School</h3>

    <p>
    I've taken two semesters of smartschool classes, and I recommend them both for the teachers and the alumni community. (I took classes from Winona and Greg + Scott's team teach, and audited Cynthia and Dan.)
    </p>

    <h3>Paul Scott Canavan</h3>

    <p>
    I've heard nonstop great things about his mentorship, and I'd love to take it myself someday! Seems like great vibes and great community too.
    </p>
    </div>

    <div className="mentorship-copy">
    <h3>Warrior Art Camp</h3>

    <p>
    I haven't taken any of these classes myself, but my friends have had positive experiences. This is a great choice if you're still working on your fundamentals, as you'll get a lot of reps in with their structured assignments.
    </p>

    <h3>Swatches Academy</h3>

    <p>
    I've seen people level up quickly with these courses, and I really like watching Clint and Diana's portfolio reviews on YouTube. They also have classes on fundamentals!
    </p>

    <h3>1:1 Mentorships</h3>

    <p>
    I've gotten super lucky by cold-emailing my favorite artists and asking them to mentor me. (Shoutout Gal Or and Micah Epstein, thank you guysss {'<3'}). I think this is a good approach if you're more self-directed and don't necessarily need a curriculum. Go on, shoot your shot!
    </p>
    </div>
    </div>
    </section>
    </main>
  );
}

function Nav(props: { className?: string }) {
  return (
    <nav className={props.className}>
      <ul>
        <li>
          <NavLink to="/" exact>Illustration</NavLink>
        </li>
        {/* <li>
          <NavLink to="/kidlit">Middle Grade & Kidlit</NavLink>
        </li> */}
        <li>
          <NavLink to="/mentorship">Mentorship</NavLink>
        </li>
        <li>
          <NavLink to="/about">About</NavLink>
        </li>
        <li>
          <a href="https://instagram.com/jessichenliu" target="_blank">
            <IconButton>
              <IconInstagram />
            </IconButton>
          </a>
        </li>
      </ul>
    </nav>
  );
}

function DesktopHeader(props: {footer?: boolean}) {
  return (
    <div className={`desktop-header ${props.footer && "footer-nav"}`}>
      {props.footer ? <span/> :(
        <NavLink to="/">
          <h1>Jessica Liu</h1>
        </NavLink>
      )}
      <Nav />
    </div>
  );
}

function MobileHeader() {
  const [navShown, setNavShown] = useState(false);

  let history = useHistory();
  history.listen(() => {
    setNavShown(false);
  });

  return (
    <div className="mobile-header">
      <h1>Jessica Liu</h1>
      <div onMouseDown={() => setNavShown(!navShown)}>
      <IconButton>
        <IconHamburger />
      </IconButton>
      </div>
      {navShown && (
        <div className="mobile-nav">
          <div className="x" onMouseDown={() => setNavShown(false)}>
            <IconButton>
              <IconX />
            </IconButton>
          </div>
          <Nav />
        </div>
      )}
    </div>
  );
}

class App extends React.Component {
  render() {
    return (
      <div className="page">
        <Router>
          <DesktopHeader />
          <MobileHeader />
          <Switch>
            <Route path="/about">
              <About />
            </Route>
            <Route path="/kidlit">
              <GalleryGrid key="kidlit" galleryRows={kidlitGalleryRows} />
              <DesktopHeader footer={true} />
            </Route>
            <Route path="/new">
              <div className="new-disclaimer">
              <strong>New works for AD review</strong> <br/> (includes unreleased, non-NDA material)
              </div>
              <GalleryGrid key="new" galleryRows={newGalleryRows} />
              <DesktopHeader footer={true} />
            </Route>
            <Route path="/wizards">
              <div className="new-disclaimer">
              <strong>New works for WotC review</strong> <br/> (includes unreleased, non-NDA material)
              </div>
              <GalleryGrid key="wizards" galleryRows={wotcGalleryRows} />
              <DesktopHeader footer={true} />
            </Route>
            <Route path="/disney">
              <div className="new-disclaimer">
              <strong>Jessica Liu's portfolio for Lorcana</strong> <br/>
              </div>
              <GalleryGrid key="disney" galleryRows={disneyRows} />
              <DesktopHeader footer={true} />
            </Route>
            <Route path="/rookandrose">
              <div className="new-disclaimer">
                <strong>Interior Illustrations for the Rook and Rose trilogy</strong> <br/>The Broken Binding, AD: Petrik Leo
              </div>
              <GalleryGrid key="rookandrose" galleryRows={rookAndRoseGalleryRows} showDescription={false} />
              <DesktopHeader footer={true} />
            </Route>
            <Route path="/authors">
              <Authors />
            </Route>
            <Route path="/mentorship">
              <Mentorship />
            </Route>
            <Route path="/">
              <GalleryGrid key="fantasy" galleryRows={illustrationGalleryRows} />
              <DesktopHeader footer={true} />
            </Route>
          </Switch>
        </Router>
        <footer className="page-footer">
          &copy; {new Date().getFullYear()} Jessica Liu
        </footer>
      </div>
    );
  }
}

export default App;
